import { h } from 'vue'

import { LlIcon } from '@ll-plus/components'
import { createNamespace } from '@ll-plus/utils'
import { message } from 'ant-design-vue'

type IMessageInfo = 'success' | 'info' | 'warning' | 'error'
export interface ILlMessage {
  success: (config) => void
  info: (config) => void
  warning: (config) => void
  error: (config) => void
}

const messageInfo: IMessageInfo[] = ['success', 'info', 'warning', 'error']
const bem = createNamespace('message')

export const llMessage = {} as ILlMessage

// 递归增加方法
messageInfo.forEach(messageItem => {
  if (Object.keys(message).includes(messageItem)) {
    llMessage[messageItem] = config => {
      // 如果显示close关闭按钮则弹窗不会自动关闭，需要手动关闭
      if (config.isShowClose) {
        config.duration = 0
      }

      // 销毁message弹窗
      const handleCloseClick = () => {
        destroyCallback && destroyCallback()
        config.onClose && config.onClose()
      }
      // message弹窗
      const destroyCallback = message[messageItem]({
        ...config,
        class: `${bem.b()} ${bem.e(messageItem)}  ${
          config.class ? config.class : ''
        }`,
        content: h(
          'div',
          { class: `${bem.e('container')} ${bem.e(config.className)}` },
          [
            // 右上角关闭图标
            config.isShowClose
              ? h(
                  'div',
                  {
                    class: `${bem.e('close')}`,
                    onClick: handleCloseClick
                  },
                  h(LlIcon, {
                    iconName: config?.iconProp?.iconName ? '' : 'icon-close2',
                    ...config.iconProp
                  })
                )
              : null,
            h('div', { class: `${bem.e('content')}` }, [
              // 头部标题区
              h('div', { class: `${bem.e('title')}` }, config.title),
              // 提示文本区
              h('div', { class: `${bem.e('des')}` }, config.text)
            ]),
            // code显示区
            h('div', { class: `${bem.e('code')}` }, config.code)
          ]
        )
      })
    }
  }
})
